import React from "react";
import { Flex, Box, Text, Icon, Button, useColorModeValue } from "@chakra-ui/react";
import { MdCardMembership, MdAdd } from "react-icons/md";

/**
 * Page header card with icon badge, title, subtitle and "Créer" button.
 * @param {Object} props
 * @param {number|null} props.total - Total subscriptions count (shown in subtitle when available)
 * @param {Function} props.onCreateClick - "Créer un abonnement" click handler
 * @returns {React.ReactElement}
 */
function SubscriptionsHeader({ total, onCreateClick }) {
    const badgeBg = useColorModeValue("brand.100", "whiteAlpha.100");
    const titleColor = useColorModeValue("secondaryGray.900", "white");
    const subColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    const subtitleText = total != null
        ? `${total} abonnement${total > 1 ? "s" : ""} au total`
        : "Vue d'ensemble des abonnements de tous les utilisateurs, groupes et entités";
    return (
        <Flex justify="space-between" align="center" gap="12px" flexWrap="wrap">
            <Flex align="center" gap="12px" minW="0">
                <Flex align="center" justify="center" w="44px" h="44px" borderRadius="12px" bg={badgeBg} flexShrink="0">
                    <Icon as={MdCardMembership} w="22px" h="22px" color="brand.500" />
                </Flex>
                <Box minW="0">
                    <Text color={titleColor} fontSize="1.05rem" fontWeight="700">Abonnements</Text>
                    <Text color={subColor} fontSize="0.75rem" noOfLines={1}>{subtitleText}</Text>
                </Box>
            </Flex>
            <Button onClick={onCreateClick} colorScheme="brand" size="sm" leftIcon={<Icon as={MdAdd} />}>
                Créer un abonnement
            </Button>
        </Flex>
    );
}

export default SubscriptionsHeader;
